import { PaymentType, PricingPlanSchema } from 'types';
import { useRouter } from 'hooks';
import { CheckedIcon } from 'components/Icon';

import styles from './Payment.Success.module.scss';

export type PaymentCompleteProps = {
  pricingPlan: PricingPlanSchema | null;
  onProceed?(): void;
};

const PaymentSuccess = ({ pricingPlan, onProceed }: PaymentCompleteProps) => {
  const router = useRouter<{
    type: PaymentType;
    pricingPlanId?: string;
    channelName?: string;
    payment_intent_client_secret: string;
  }>();
  const {
    params: { channelName }
  } = router;

  const renderContent = () => {
    const paymentType = router.params.type;

    switch (paymentType) {
      case PaymentType.CREATOR: {
        if (pricingPlan) {
          return (
            <div className={styles.container}>
              <CheckedIcon />
              <h3>Success</h3>
              <p>You purchased "{pricingPlan.name}" plan</p>
              <button type="button" className={styles.start} onClick={onProceed}>
                Go to my channel
              </button>
            </div>
          );
        }

        return null;
      }

      case PaymentType.MEMBER: {
        if (pricingPlan && channelName) {
          return (
            <div className={styles.container}>
              <CheckedIcon />
              <h3>Success</h3>
              <p>You became a member of "{channelName}" channel</p>
              <button type="button" className={styles.start} onClick={onProceed}>
                Start watching
              </button>
            </div>
          );
        }

        return null;
      }

      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};

export default PaymentSuccess;
